window.tbg = window.tbg || {};
window.tbg.httpService = (function ($, Promise, REST_ROOT_URL) {
    'use strict';

    if (!$ || !Promise || !REST_ROOT_URL) {
        console.warn('Could not initialize httpService. Dependencies not met.');
        return;
    }

    return function httpService (config) {
        var request;
        var prefix = config.hasOwnProperty('urlPrefix') ? config.urlPrefix : REST_ROOT_URL;
        var requestConfig = Object.assign({ method: 'GET' }, config, { url: prefix + config.url });

        if (requestConfig.params) {
            requestConfig.data = Object.assign({}, requestConfig.data, requestConfig.params);
        }

        request = $.ajax(requestConfig);

        return new Promise(function (resolve, reject) {
            request.then(resolve, function errorResponse (jqXHR, textStatus, e) {
                if (jqXHR && jqXHR.responseJSON) {
                    var errorPayload = Object.assign({}, jqXHR.responseJSON, { _httpStatus: jqXHR.status });
                    reject(errorPayload);
                } else {
                    reject(jqXHR || e);
                }
            });
        });
    };
}(window.jQuery, window.Promise, window.REST_ROOT_URL || '/rest/storefront')); // TODO: Put storefront rest root url global as well...
